export const mergeSwitchWtParams = (
  globalWtParams,
  itemWtParams,
  itemParams
) => {
  const mergedWtParams = {
    // APPROVAL
    ...(globalWtParams.doctype &&
      window.wtTrackingCategories.APPROVAL.indexOf(
        globalWtParams.doctype.toUpperCase()
      ) !== -1 && {
        certBody: itemParams.approvalauthority,
        certType:
          itemParams.keywords.length > 0
            ? (function() {
                const [firstKeyword] = [...itemParams.keywords].sort();
                return typeof firstKeyword === "string"
                  ? firstKeyword
                  : firstKeyword.keyword;
              })()
            : undefined
      }),
    // NEWS
    ...(globalWtParams.doctype &&
      window.wtTrackingCategories.NEWS.indexOf(
        globalWtParams.doctype.toUpperCase()
      ) !== -1 && {
        type: "URL"
      }),
    ...globalWtParams,
    ...itemWtParams
  };

  return mergedWtParams;
};
